import {_RECURRING_BILLING,
        UPDATE_PREV_SUCC_STEP, 
        RESET_CONFIGURATION, 
        RECURRING_PURCHASE_SUCCESS, 
        RECURRING_PURCHASE_SENT,
        RECURRING_PURCHASE_FAIL,
        RECURRING_UPDATE_SUCCESS,
        RECURRING_UPDATE_SENT,
        RECURRING_UPDATE_FAIL,
        UPDATE_STORE_ID,
        UPDATE_PAN,
        UPDATE_ORDER_ID,
        UPDATE_EXPDATE,
        UPDATE_CURRENCY,
        UPDATE_API_TOKEN,
        UPDATE_AMOUNT,
        UPDATE_ON_EDIT_ID
    } from '../../actions/types'

const initialState = {
    prevSuccStep: 0, // the id of the most recent successful transaction (step)
    purchaseResponse: "No request has been made.",
    updateResponse: "No request has been made.",
    loading: false,
    purchaseSuccess: false,
    updateSuccess: false,
    config: {
        storeId: "store2",
        apiToken: "yesguy",
        orderId: "Test123456789",
        pan: "4242424242424242", //4606633870436092
        expdate: "2310",
        amount: "1.00",
        currency: "124",
        onEditId: 'none'
    },
    history: []
}

// eslint-disable-next-line
export default function(state = initialState, action) {
    if(action.feature === _RECURRING_BILLING) {
        switch(action.type) {
            case UPDATE_PREV_SUCC_STEP:
                return { ...state, prevSuccStep: action.payload }
            //purchase
            case RECURRING_PURCHASE_SENT:
                return { ...state, loading: true, purchaseSuccess: false, history: [] }
            case RECURRING_PURCHASE_SUCCESS:
                return { ...state, history: [2], purchaseResponse: action.payload, loading: false, purchaseSuccess: true }
            case RECURRING_PURCHASE_FAIL:
                return { ...state, history: [], purchaseResponse: action.payload, loading: false, purchaseSuccess: false }
            //update
            case RECURRING_UPDATE_SENT:
                return { ...state, loading: true, updateSuccess: false , history: [] }
            case RECURRING_UPDATE_SUCCESS:
                return { ...state, history: [3], updateResponse: action.payload, loading: false, updateSuccess: true }
            case RECURRING_UPDATE_FAIL:
                return { ...state,  history: [],updateResponse: action.payload, loading: false, updateSuccess: false }

                
            case RESET_CONFIGURATION:
                return { ...state, config: initialState.config }  
            case UPDATE_AMOUNT:
                return { ...state, config: { ...state.config, amount: action.payload }}
            case UPDATE_API_TOKEN:
                return { ...state, config: { ...state.config, apiToken: action.payload }}
            case UPDATE_CURRENCY:
                return { ...state, config: { ...state.config, currency: action.payload }}
            case UPDATE_EXPDATE:
                return { ...state, config: { ...state.config, expdate: action.payload }}
            case UPDATE_ORDER_ID:
                return { ...state, config: { ...state.config, orderId: action.payload }}
            case UPDATE_PAN:
                return { ...state, config: { ...state.config, pan: action.payload }}
            case UPDATE_STORE_ID:
                return { ...state, config: { ...state.config, storeId: action.payload }}
            case UPDATE_ON_EDIT_ID:
                return { ...state, config: { ...state.config, onEditId: action.payload }}
    

    
    
            default:
                return state
        }
    }
    else {
        return state
    }
}